import script from "./Binding_Choose.vue?vue&type=script&setup=true&lang=js"
export * from "./Binding_Choose.vue?vue&type=script&setup=true&lang=js"

import "./Binding_Choose.vue?vue&type=style&index=0&id=e0803c00&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0803c00"]])

export default __exports__